import { type IconProps } from './Icon.types';

const FacebookIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width,
  height,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fill}
      d="M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM16.5634 15.6589V23.8197H13.1869V15.6592H11.5V12.8469H13.1869V11.1585C13.1869 8.86425 14.1394 7.5 16.8457 7.5H19.0988V10.3126H17.6905C16.637 10.3126 16.5673 10.7056 16.5673 11.4391L16.5634 12.8466H19.1147L18.8162 15.6589H16.5634Z"
    />
  </svg>
);

export default FacebookIcon;